// extracted by mini-css-extract-plugin
module.exports = {"choice":"Choice-module__choice___1jmQ_"};